// import sealImg from "../../Images/AppBar/seal_glacier_blue.png";
// import sealionImg from "../../Images/AppBar/sealion-7-ev-header-adjust.png";

import destroyer_05_img from "../../Images/AppBar/CarModels/PNG_Destroyer_05.png";
import dolphin_img from "../../Images/AppBar/CarModels/PNG_Dolphin.png";
import sea_lion_05_dmi_img from "../../Images/AppBar/CarModels/PNG_Sea_Lion_05.png";
import seal_06_dmi_img from "../../Images/AppBar/seal_glacier_blue.png";
import song_plus_dmi_img from "../../Images/AppBar/CarModels/PNG_Song_Plus.png";
import song_pro_img from "../../Images/AppBar/CarModels/PNG_Song_Pro.png";
import seagull_img from "../../Images/AppBar/CarModels/PNG_Seagull.png";  

export const headerHeight = "60px";
export const languageMenuHeight = "50px";
export const carsMenuHeight = "170px";

export const buttons: { path: string; name: string }[] = [
  { path: "/", name: "home" },
  { path: "/", name: "BYD" },
  // { path: "/AboutUs", name: "about_us" },
  { path: "/Service", name: "service" },
  { path: "/TradeIn", name: "trade_in" },
  { path: "/Guarantee", name: "guarantee" },
  { path: "/ContactUs", name: "contact_us" },
  // { path: "/TestDrive", name: "test_drive" },
];

export const languages = [
  {
    name: "English",
    lng: "en",
  },
  {
    name: "Română",
    lng: "ro",
  },
  {
    name: "Русский",
    lng: "ru",
  },
];

export const carModelsMenu = [
  {
    id: 3,
    name: "DOLPHIN",
    img: dolphin_img,
    type: "electric",
  },
  {
    id: 1,
    name: "SONG PLUS DM-i",
    img: song_plus_dmi_img,
    type: "hybrid",
  },
  {
    id: 2,
    name: "DESTROYER 05",
    img: destroyer_05_img,
    type: "hybrid",
  },
  {
    id: 4,
    name: "SEA LION 05 DM-i",
    img: sea_lion_05_dmi_img,
    type: "hybrid",
  },
  {
    id: 5,
    name: "SEAL 06 DM-i",
    img: seal_06_dmi_img,
    type: "hybrid",
  },
  {
    id: 6,
    name: "SONG PRO",
    img: song_pro_img,
    type: "hybrid",
  },
  {
    id: 7,
    name: "SEAGULL",
    img: seagull_img,
    type: "electric",
  },
];


